import { ApiBase } from "./api-base";
import { appConfig } from "../config/Config";

export class HttpMainApi extends ApiBase {
  onApiName(): string {
    return "AdminMainApi";
  }

  onUrlPath(): string {
    if (window.location.hostname === "localhost") return appConfig.testApiUrl;
    else return appConfig.mainApiUrl;
  }

  public async put_member_join(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_member_join";
    const response = this.requestPost(requestBody);
    return response;
  }
  public async put_member_ch_password(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_member_ch_password";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_member_login(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_member_login";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_password_check(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_password_check";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_reserv_time(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_reserv_time";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_reserv_month(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_reserv_month";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_month_reserv_data(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_month_reserv_data";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_my_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_my_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }
  public async get_price(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_price";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_my_study_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_my_study_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_month_reserv_data(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_month_reserv_data";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_my_reservation_diff_check(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_my_reservation_diff_check";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_one_hour_check(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_one_hour_check";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_my_reservation_check(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_my_reservation_check";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_user_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_user_list";
    const response = this.requestPost(requestBody);
    return response;
  }
  public async update_user_password(param: any) {
    let requestBody: any = param;
    requestBody.command = "update_user_password";
    const response = this.requestPost(requestBody);
    return response;
  }
  public async update_user_delete(param: any) {
    let requestBody: any = param;
    requestBody.command = "update_user_delete";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async update_user_age_group(param: {
    sk: string;
    ageGroup: "성인" | "미성년자";
    adminUserId: string;
  }) {
    return this.requestPost({ ...param, command: "update_user_age_group" });
  }

  public async get_user_finger_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_user_finger_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_locker_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_locker_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_book_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_book_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_book_new_list(param: any) {
    console.log("param : ", param);
    let requestBody: any = param;
    requestBody.command = "get_book_new_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  // New mobile book landing endpoint. Existing book search/new-book APIs remain unchanged.
  public async get_book_home(param: any = {}) {
    let requestBody: any = param;
    requestBody.command = "get_book_home";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async resolve_book_barcode(param: any) {
    const requestBody: any = param;
    requestBody.command = "resolve_book_barcode";
    return this.requestPost(requestBody);
  }

  public async resolve_book_by_sk(param: any) {
    const requestBody: any = param;
    requestBody.command = "resolve_book_by_sk";
    return this.requestPost(requestBody);
  }

  public async borrow_book(param: any) {
    const requestBody: any = param;
    requestBody.command = "borrow_book";
    return this.requestPost(requestBody);
  }

  public async return_book(param: any) {
    const requestBody: any = param;
    requestBody.command = "return_book";
    return this.requestPost(requestBody);
  }

  public async return_my_book_loan(param: any) {
    const requestBody: any = param;
    requestBody.command = "return_my_book_loan";
    return this.requestPost(requestBody);
  }

  public async get_my_active_book_loans(param: any) {
    const requestBody: any = param;
    requestBody.command = "get_my_active_book_loans";
    return this.requestPost(requestBody);
  }

  public async get_active_library_book_loans(param: any = {}) {
    const requestBody: any = param;
    requestBody.command = "get_active_library_book_loans";
    return this.requestPost(requestBody);
  }

  public async get_popular_library_books(param: any = {}) {
    const requestBody: any = param;
    requestBody.command = "get_popular_library_books";
    return this.requestPost(requestBody);
  }

  public async get_next_month_info(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_next_month_info";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async update_locker_password(param: any) {
    let requestBody: any = param;
    requestBody.command = "update_locker_password";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async update_locker_user(param: any) {
    let requestBody: any = param;
    requestBody.command = "update_locker_user";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_user_finger_community_info(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_user_finger_community_info";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async update_user_finger(param: any) {
    let requestBody: any = param;
    requestBody.command = "update_user_finger";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_account_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_account_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_account_inout_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_account_inout_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_account_all_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_account_all_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_integrated_account_breakdown(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_integrated_account_breakdown";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_my_account_all_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_my_account_all_list";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async update_price(param: any) {
    let requestBody: any = param;
    requestBody.command = "update_price";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_kvs_play(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_kvs_play";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_cancel_my_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_cancel_my_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_cancel_my_reservation_price(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_cancel_my_reservation_price";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_day_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_day_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_robot_cleaner_month_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_robot_cleaner_month_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_robot_cleaner_availability(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_robot_cleaner_availability";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_table_tennis_policy(param: any = {}) {
    const requestBody: any = param;
    requestBody.command = "get_table_tennis_policy";
    return this.requestPost(requestBody);
  }

  public async get_table_tennis_day_availability(param: any) {
    const requestBody: any = param;
    requestBody.command = "get_table_tennis_day_availability";
    return this.requestPost(requestBody);
  }

  public async create_table_tennis_reservation(param: any) {
    const requestBody: any = param;
    requestBody.command = "create_table_tennis_reservation";
    return this.requestPost(requestBody);
  }

  public async get_my_table_tennis_reservations(param: any) {
    const requestBody: any = param;
    requestBody.command = "get_my_table_tennis_reservations";
    return this.requestPost(requestBody);
  }

  public async cancel_table_tennis_reservation_slots(param: any) {
    const requestBody: any = param;
    requestBody.command = "cancel_table_tennis_reservation_slots";
    return this.requestPost(requestBody);
  }

  public async get_book_cafe_policy(param: any = {}) {
    const requestBody: any = param;
    requestBody.command = "get_book_cafe_policy";
    return this.requestPost(requestBody);
  }

  public async get_book_cafe_day_availability(param: any) {
    const requestBody: any = param;
    requestBody.command = "get_book_cafe_day_availability";
    return this.requestPost(requestBody);
  }

  public async create_book_cafe_reservation(param: any) {
    const requestBody: any = param;
    requestBody.command = "create_book_cafe_reservation";
    return this.requestPost(requestBody);
  }

  public async get_my_book_cafe_reservations(param: any) {
    const requestBody: any = param;
    requestBody.command = "get_my_book_cafe_reservations";
    return this.requestPost(requestBody);
  }

  public async cancel_book_cafe_reservation_slots(param: any) {
    const requestBody: any = param;
    requestBody.command = "cancel_book_cafe_reservation_slots";
    return this.requestPost(requestBody);
  }

  public async get_my_robot_cleaner_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_my_robot_cleaner_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_robot_cleaner_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_robot_cleaner_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_cancel_robot_cleaner_reservation(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_cancel_robot_cleaner_reservation";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async put_dashboard_event(param: any) {
    let requestBody: any = param;
    requestBody.command = "put_dashboard_event";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_dashboard_daily_stats(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_dashboard_daily_stats";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_dashboard_event_detail(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_dashboard_event_detail";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_weekly_weather_info(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_weekly_weather_info";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_hourly_weather_info(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_hourly_weather_info";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async get_holiday_list(param: any) {
    let requestBody: any = param;
    requestBody.command = "get_holiday_list";
    const response = this.requestPost(requestBody);
    return response;
  }
  public async update_repair(param: any) {
    let requestBody: any = param;
    requestBody.command = "update_repair";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async today_check(param: any) {
    let requestBody: any = param;
    requestBody.command = "today_check";
    const response = this.requestPost(requestBody);
    return response;
  }

  public async post(param: any) {
    const response = await this.requestPost(param);
    return response;
  }
}
